// efで離脱時にだすアラートのイベント解除に使う
export const efUnloadEvent = (event) => {
    event.returnValue = '';
    return '';
};
